// extracted by mini-css-extract-plugin
export default {"card":"o3-z","carouselContainer":"p3-z","carouselContent":"q3-z"};